
import TruckRemove from "../../../assets/duotone/TruckRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TruckRemoveIcon({ className, dataTestid = "TruckRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TruckRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
